import { render, staticRenderFns } from "./ketogenesis2.vue?vue&type=template&id=6133dd72&scoped=true&"
import script from "./ketogenesis2.vue?vue&type=script&lang=js&"
export * from "./ketogenesis2.vue?vue&type=script&lang=js&"
import style0 from "./ketogenesis2.vue?vue&type=style&index=0&id=6133dd72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6133dd72",
  null
  
)

export default component.exports